import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../Js/React/loader';
import OneProfile from '../../FrontEndReact/src/Core/Components/Profile/OneProfile';
import { User } from '../../FrontEndReact/src/Core/Types/user';
import BizProfileToplists from '../../FrontEndReact/src/Core/Components/Toplist/BizProfileToplists';
import { withFrontendContext } from '../Common/frontendStateContext';
import TimereportMain from '../../FrontEndReact/src/Modules/Timereport';
import ExternalTicketPortal from '../../FrontEndReact/src/Modules/ExternalTickets';

let root: Root | undefined;
AddBizReactLoader(root, 'bizuserprofile', (e) => {
	const params = (e.detail as { params: { userId: number; userObject: User } }).params;
	return <OneProfile userId={params.userId} userObject={params.userObject} />;
});

AddBizReactLoader(root, 'bizprofiletoplists', () => {
	return withFrontendContext(<BizProfileToplists legacy />);
});

AddBizReactLoader(root, 'biztimereport', () => {
	return withFrontendContext(<TimereportMain />);
});

AddBizReactLoader(root, 'bizexternaltickets', () => {
	return withFrontendContext(<ExternalTicketPortal />);
});

